export default __webpack_public_path__ + "static/Poppins-Medium-673ed42382ab264e0bf5b33f3579568c.ttf";